<div class="page-content">
  <app-equipamentos-nav [currentType]="'armas'" [currentTotal]="navTotal" />

  <!-- Banner de alta segurança -->
  <div class="security-banner">
    <i class="pi pi-shield security-banner__icon"></i>
    <div class="security-banner__body">
      <strong>Módulo de Alta Segurança</strong>
      <span>Armamento controlado — registo e movimentações auditados pelo
        sistema</span>
    </div>
    <button class="btn-secondary" disabled pTooltip="Endpoint de auditoria a confirmar com o backend"
      tooltipPosition="left">
      <i class="ri-file-list-3-line"></i> Log de Auditoria
    </button>
  </div>

  <div class="equipment-view-tabs" role="tablist" aria-label="Vista de armas">
    <button type="button" class="equipment-view-tab" [class.active]="activeSection === 'list'"
      (click)="activeSection = 'list'">
      <i class="ri-shield-line"></i> Invent&aacute;rio
    </button>
    <button type="button" class="equipment-view-tab" [class.active]="activeSection === 'configuration'"
      (click)="activeSection = 'configuration'">
      <i class="ri-settings-3-line"></i> Configura&ccedil;&atilde;o
    </button>
  </div>

  <!-- KPIs -->
  <div class="equip-tab active">
    <div class="inner-panel active" *ngIf="activeSection === 'list'">
      <app-equipamento-kpi-grid [items]="kpiItems" [columns]="5" />

      <p-menu #rowMenu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>

      <!-- FILTER BAR -->
      <div class="table-actions-row">
        <div class="filter-bar-left">
          <div class="search-wrap">
            <i class="ri-search-line search-icon"></i>
            <input
              type="text"
              pInputText
              [(ngModel)]="searchTerm"
              class="search-input"
              placeholder="Pesquisar por nº de série, tipo ou responsável..."
            />
            <button type="button" class="search-clear" *ngIf="searchTerm" (click)="searchTerm = ''">
              <i class="ri-close-line"></i>
            </button>
          </div>

          <div class="quick-filter-pills">
            <button
              type="button"
              class="filter-pill"
              [class.active]="activeQuickFilter === f"
              *ngFor="let f of quickFilters"
              (click)="setQuickFilter(f)"
            >
              {{ f }}
            </button>
          </div>
        </div>

        <button type="button" class="btn-web-primary" (click)="openCreateDrawer()">
          <i class="fas fa-plus"></i> Registar Arma
        </button>
      </div>

      <!-- TABLE -->
      <div class="data-table-wrapper">
        <div *ngIf="loading" class="skeleton-rows">
          <p-skeleton height="48px" *ngFor="let i of [1, 2, 3, 4, 5, 6]" styleClass="mb-2"></p-skeleton>
        </div>

        <div *ngIf="!loading">
          <app-empty-state *ngIf="filteredEquipamentos.length === 0" icon="pi pi-shield" title="Nenhuma arma encontrada"
            [message]="
              hasLocalFilters
                ? 'Sem resultados para a pesquisa actual.'
                : 'Registe a primeira arma.'
            " actionLabel="Registar Arma" (action)="openCreateDrawer()">
          </app-empty-state>

          <table class="data-table armas-table" *ngIf="filteredEquipamentos.length > 0">
            <thead>
              <tr>
                <th>Nº Série</th>
                <th>Tipo / Marca</th>
                <th>Calibre</th>
                <th>Nº Licença</th>
                <th>Posto</th>
                <th>Responsável</th>
                <th>Estado</th>
                <th>Última Verificação</th>
                <th class="text-right">Acções</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let e of filteredEquipamentos" class="clickable-row" (click)="verDetalhe(e)">
                <!-- 1. Nº Série (foto + série) -->
                <td class="col-numero-serie">
                  <div class="serie-wrapper">
                    <div class="equip-thumb equip-thumb--sm" [ngClass]="getArmaEstadoClass(e) || 'badge-default'">
                      <app-equipment-photo
                        [src]="e.fotoUrl"
                        [alt]="'Fotografia da arma'"
                        [fallbackIcon]="'pi pi-shield'"
                      />
                    </div>
                    <div class="serie-text-box">
                      <span class="serie-badge">{{ getPropriedadeValor(e, "NUMERO_SERIE") || "—" }}</span>
                      <span class="serie-subcode" *ngIf="e.codigoInterno">{{ e.codigoInterno }}</span>
                    </div>
                  </div>
                </td>

                <!-- 2. Tipo / Marca (tipo + marca/fabricante + país de origem) -->
                <td class="col-tipo-marca">
                  <div class="tipo-marca-box">
                    <span class="tipo-title">
                      {{ getPropriedadeValor(e, "TIPO") || "—" }}
                    </span> <span class="marca-sub">
                      {{ getPropriedadeValor(e, "MARCA") || "" }}
                      <ng-container *ngIf="getPropriedadeValor(e, 'PAIS_ORIGEM')">
                        · {{ getPropriedadeValor(e, "PAIS_ORIGEM") }}
                      </ng-container>
                    </span>
                  </div>
                </td>

                <!-- 3. Calibre -->
                <td class="col-calibre">{{ getPropriedadeValor(e, "CALIBRE") || "—" }}</td>

                <!-- 4. Nº Licença -->
                <td class="col-licenca">{{ getPropriedadeValor(e, "NUMERO_LICENCA") || "—" }}</td>

                <!-- 5. Posto -->
                <td class="col-posto">
                  <div class="posto-box" *ngIf="getPostoNome(e) !== 'Sem posto' && getPostoNome(e) !== '—'; else semPosto">
                    <i class="ri-map-pin-2-line"></i>
                    <span>{{ getPostoNome(e) }}</span>
                  </div>
                  <ng-template #semPosto>
                    <span class="text-muted-dash">—</span>
                  </ng-template>
                </td>

                <!-- 6. Responsável -->
                <td class="col-responsavel">
                  <span [class.text-muted-dash]="!getResponsavel(e)">
                    {{ getResponsavel(e) }}
                  </span>
                </td>

                <!-- 7. Estado -->
                <td class="col-estado">
                  <span class="badge" [ngClass]="getArmaEstadoClass(e)">
                    {{ getArmaEstadoLabel(e) }}
                  </span>
                </td>

                <!-- 8. Última Verificação (última + próxima) -->
                <td class="col-ultima-verificacao">
                  <div class="verificacao-box">
                    <span>
                      <i class="ri-check-double-line"></i>
                      {{ getPropriedadeValor(e, "DATA_ULTIMA_VERIFICACAO") ? (getPropriedadeValor(e, "DATA_ULTIMA_VERIFICACAO") | date:'dd/MM/yyyy') : "—" }}
                    </span>
                    <span class="verif-proxima">
                      <i class="ri-calendar-line"></i>
                      {{ getPropriedadeValor(e, "PROXIMA_VERIFICACAO_OBRIGATORIA") ? (getPropriedadeValor(e, "PROXIMA_VERIFICACAO_OBRIGATORIA") | date:'dd/MM/yyyy') : "—" }}
                      <span class="tag-atrasada" *ngIf="isVerificacaoAtrasada(e)">Atrasada</span>
                    </span>
                  </div>
                </td>

                <!-- 9. Acções -->
                <td class="actions" (click)="$event.stopPropagation()">
                  <button class="btn-dots" type="button" (click)="openRowMenu($event, e)" title="Opções da Arma">
                    <i class="pi pi-ellipsis-v"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="equipment-pagination" *ngIf="!hasLocalFilters && totalRecords > 0">
            <app-paginator-control
              [first]="pageFirst"
              [rows]="pageSize"
              [totalRecords]="totalRecords"
              [rowsPerPageOptions]="[10, 20, 50]"
              (pageChange)="onPageChange($event)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="inner-panel active configuration-panel-host" *ngIf="activeSection === 'configuration'">
      <app-tipos-equipamento [embedded]="true" [presetTipoId]="1" />
    </div>
  </div>

<p-drawer [(visible)]="showCreateDrawer" position="right" [modal]="true" [blockScroll]="true"
    header="Registar Nova Arma" styleClass="equip-create-drawer">
    <app-novo-equipamento *ngIf="showCreateDrawer" [drawerMode]="true" [presetTipoId]="1"
      (closed)="showCreateDrawer = false" (saved)="onEquipmentSaved()"
      [IdCategoriaEquipamento]="IdCategoriaEquipamento" />
  </p-drawer>

  <p-drawer [(visible)]="showAtribuirDrawer" position="right" [modal]="true" [blockScroll]="true"
    header="Atribuir Arma a Posto" styleClass="equip-assign-drawer">
    <ng-container *ngIf="armaParaAtribuir">
      <div class="assign-gun-card">
        <div class="assign-gun-info">
          <div class="equip-thumb equip-thumb--sm" [ngClass]="getArmaEstadoClass(armaParaAtribuir) || 'badge-default'">
            <app-equipment-photo
              [src]="armaParaAtribuir.fotoUrl"
              [alt]="'Fotografia da arma'"
              [fallbackIcon]="'pi pi-shield'"
            />
          </div>
          <div>
            <span class="assign-gun-serie">{{ getPropriedadeValor(armaParaAtribuir, "NUMERO_SERIE") || armaParaAtribuir.codigoInterno || "—" }}</span>
            <span class="assign-gun-sub">{{ getArmaEstadoLabel(armaParaAtribuir) }}</span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">Posto destino <span class="req">*</span></label>
        <p-select
          [options]="postos"
          [(ngModel)]="atribuirPostoId"
          optionLabel="label"
          optionValue="value"
          [loading]="postosLoading"
          placeholder="Selecione o posto ou unidade"
          styleClass="w-full"
        ></p-select>
      </div>

      <div class="drawer-actions">
        <button type="button" class="btn-secondary" (click)="closeAtribuirDrawer()"
          [disabled]="atribuirSubmitting">
          Cancelar
        </button>
        <button type="button" class="btn-web-primary" (click)="confirmarAtribuicao()"
          [disabled]="atribuirPostoId == null || atribuirSubmitting">
          <i class="pi pi-user-plus"></i>
          {{ atribuirSubmitting ? 'A atribuir...' : 'Confirmar Atribuição' }}
        </button>
      </div>
    </ng-container>
  </p-drawer>
</div>
